import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CardHeader',
  props: {
  companyName: {
    type: String,
    required: true,
  },
},
  setup(__props) {



return { __sfc: true, }
}

})